import GetIndividualProjectByIdRequestModelBase from '../_generated/modelBases/get-individual-project-by-id-request-model-base';

export default class GetIndividualProjectByIdRequestModel extends GetIndividualProjectByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
